import React from 'react'
import styled from 'styled-components'
import theme from 'stories/utils/theme'
import { Know, KnowTranscript } from 'interfaces/Know'
import { AnalyticsEventKnowConversionImageButtonClick } from 'lib/constants/AnalyticsEventType'
import { trackEvent } from 'lib/tracking/analytics-service'
import { getAltTextFromTranscript } from 'lib/features/Know/know'
import { redirectToAppDownloadUrlAsync } from 'lib/features/app-links'
import { StandardSubtitle } from 'stories/elements/Typography/Text'
import _useTranslation from 'lib/hooks/_useTranslation'
import Expand from 'assets/know/line_expand.svg'
import NextImage from 'components/elements/NextImage'

const Container = styled.div<{ showTrialProFeatures?: boolean }>`
    height: ${({ showTrialProFeatures }) => (showTrialProFeatures ? 500 : 400)}px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 5px 20px;
    z-index: 1;
    position: relative;

    .wrapper {
        position: relative;
        width: 100%;
    }
    .background-image {
        overflow: hidden;
        object-fit: cover;
        object-position: top;
        border-radius: ${theme.borderRadius.card};
        z-index: 0;
        filter: blur(2px);
        -webkit-filter: blur(2px);
        cursor: pointer;
    }
    .filter {
        position: absolute;
        background-color: rgba(9, 12, 15, 0.05);
        border-radius: ${theme.borderRadius.card};
        z-index: 2;
        height: ${({ showTrialProFeatures }) => (showTrialProFeatures ? 500 : 400)}px;
        width: 100%;
    }

    gap: 0px;
    align-items: center;
    width: 100%;
    margin: 0;
`

const BackgroundImage = styled(NextImage)`
    width: 100%;
`

const GrayButtonWrapper = styled.button`
    all: unset;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    position: absolute;
    cursor: pointer;
    bottom: 150px;
    z-index: 9;
    width: auto;
    padding: 12.5px 25px;
    border-radius: ${theme.borderRadius.normal};
    background-color: ${theme.colors.deepSeaBlue};
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
`

interface Props {
    know: Know
    referrerScreen: string | undefined
    downloadDeepLinkPath?: string
    transcript?: KnowTranscript | null
}

const BlurredMobileImage = ({ know, referrerScreen, downloadDeepLinkPath, transcript }: Props) => {
    const { t } = _useTranslation('common')

    const handleConversionDialogButtonClick = () => {
        trackEvent(AnalyticsEventKnowConversionImageButtonClick, {
            know: know ?? undefined,
            useBeacon: true,
            referrerScreen,
        })
    }

    const onContentClick = () => {
        handleConversionDialogButtonClick()

        redirectToAppDownloadUrlAsync('dynamic', 'know-mobile-blurred-preview-button', downloadDeepLinkPath)
    }

    return (
        <Container onClick={onContentClick}>
            <div className="wrapper">
                <div className="filter" />
                <BackgroundImage
                    priority
                    src={know.thumbnailSmallUrl ?? know.thumbnailMediumUrl}
                    alt={getAltTextFromTranscript(transcript ?? null) ?? know.title}
                    height={400}
                    width={300}
                    loading="eager"
                    className="background-image"
                />
            </div>

            <GrayButtonWrapper>
                <Expand />
                <StandardSubtitle fontFamily="var(--font-inter)" fontSize={16} fontWeight={600} color={theme.colors.white}>
                    {t('common/open')}
                </StandardSubtitle>
            </GrayButtonWrapper>
        </Container>
    )
}

export default BlurredMobileImage
